import { Flex, Text } from '@chakra-ui/react';

type TopCompaniesContentProps = {
  companies: string[];
  nodeName: string;
};

export const TopCompaniesContent = ({
  companies,
  nodeName,
}: TopCompaniesContentProps) => (
  <Flex direction="column" gap={2}>
    <Text color="white" fontSize="sm" fontWeight="semibold">
      {nodeName}
    </Text>
    <Text color="white" fontSize="xs">
      <Text as="span" color="white" fontWeight="semibold">
        Top Companies:{' '}
      </Text>
      <Text as="span" color="white" opacity={0.6}>
        {companies.join(', ')}
      </Text>
    </Text>
  </Flex>
);
